import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=0881ba8f&scoped=true"
import script from "./Lessons.vue?vue&type=script&lang=js"
export * from "./Lessons.vue?vue&type=script&lang=js"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=0881ba8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881ba8f",
  null
  
)

export default component.exports